/**
 * Orca Repository Contract tab — eagerly registers the route + per-repo
 * `beforeLoad` SSR loader, but defers the component + atom imports via
 * `contract.lazy.tsx` so the orca-admin chunk stays out of every other route's
 * bundle.
 *
 * The eager file may import NO atoms/components/design modules (bundle budgets):
 * the v5 frame's stylesheet is linked from {@link repoContractHead} via the pure
 * `~/lib/orcaloops-head.ts` (web CLAUDE.md rule 6).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { orcaRepoDetailBeforeLoad } from "~/lib/orca-ssr.ts";
import { orcaloopsStylesheetLinks } from "~/lib/orcaloops-head.ts";

/**
 * The page's head: the orcaloops frame stylesheet, render-blocking, so the SSR
 * markup paints styled.
 *
 * @since 1.0.0
 */
export const repoContractHead = () => ({ links: orcaloopsStylesheetLinks });

export const Route = createFileRoute("/orca/repos/$owner/$name/contract")({
  beforeLoad: orcaRepoDetailBeforeLoad,
  head: repoContractHead,
});
